import _ from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import Log from '../../utils/Debug';

import {
  KEY_MANAGER_FETCH_KEYS,
  KEY_MANAGER_CREATE_KEY,
  KEY_MANAGER_FETCH_KEYS_ERROR,
  KEY_MANAGER_CREATE_KEY_ERROR,
} from './keyManagerConstants';

import {
  fetchKeysLoadingAction,
  fetchKeysErrorAction,
  fetchKeysSuccessAction,
  createKeySuccessAction,
  createKeyLoadingAction,
  createKeyErrorAction,
} from './keyManagerReducers';

const A_HUNDRED_YEARS = 100 * 365 * 24 * 60 * 60 * 1000;

export default (bottle) => {
  bottle.factory('keyManagerFetchSaga', ({ fetchKeys }) => function* keyManagerFetchSaga() {
    Log.info('----- keyManagerFetchSaga -----');
    yield takeLatest(KEY_MANAGER_FETCH_KEYS, fetchKeys);
  });

  bottle.factory('keyManagerCreateKeySaga', ({ createKey }) => function* keyManagerCreateKeySaga() {
    Log.info('----- keyManagerCreateKeySaga -----');
    yield takeLatest(KEY_MANAGER_CREATE_KEY, createKey);
  });

  bottle.factory('fetchKeys', ({ keyManagerFetchKeys }) => function* fetchKeys() {
    Log.info('----- fetchKeys saga starting... -----');
    yield put(fetchKeysLoadingAction(0));
    try {
      const [token] = yield select(state => [
        _.get(state, 'users.idToken'),
      ]);
      if (!token) {
        yield put({ type: KEY_MANAGER_FETCH_KEYS_ERROR, error: 'Ephemeral Bearer Token is not available' });
        return;
      }
      const response = yield call(keyManagerFetchKeys, token);
      const allKeys = _.get(response, 'data.keys');
      // allKeys: [{`id`, `lastSix`, `issued`}]
      if (Array.isArray(allKeys)) {
        yield put(fetchKeysSuccessAction(allKeys));
      } else {
        yield put(fetchKeysErrorAction('Unable to fetch keys'));
      }
    } catch (err) {
      Log.error('fetchKeys error:', err);
      yield put(fetchKeysErrorAction(err));
    }
  });

  bottle.factory('createKey', ({ keyManagerCreateKey, keyManagerFetchKeys }) => function* createKey() {
    Log.info('----- createKey saga -----');
    yield put(createKeyLoadingAction(0));
    try {
      const [token] = yield select(state => [
        _.get(state, 'users.idToken'),
      ]);
      if (!token) {
        yield put({ type: KEY_MANAGER_CREATE_KEY_ERROR, error: 'Ephemeral Bearer Token is not available' });
        return;
      }
      // Repsonse data includes: bearerToken, expirationDate, id, issued, lastSix
      const response = yield call(keyManagerCreateKey, token, { ttlMillis: A_HUNDRED_YEARS });
      const bearerToken = _.get(response, 'data.bearerToken');
      if (bearerToken) {
        yield put(createKeySuccessAction(bearerToken));

        // --- pasting fetch action here.

        const response2 = yield call(keyManagerFetchKeys, token);
        console.log('response for fetch keys: ', response2);
        const allKeys = _.get(response2, 'data.keys');
        // allKeys: [{`id`, `lastSix`, `issued`}]
        if (Array.isArray(allKeys)) {
          yield put(fetchKeysSuccessAction(allKeys));
        } else {
          yield put(fetchKeysErrorAction('Unable to fetch keys'));
        }
      } else {
        yield put(createKeyErrorAction('Unable to create bearer token'));
      }
    } catch (err) {
      yield put(createKeyErrorAction(err));
    }
  });
};
